var _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPaperPlaneIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 21 21"
}, props), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
  id: "paper-plane-icon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.5.5h20v20H.5z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#paper-plane-icon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.25 1.932 4.823 17.352c.334.163.7.249 1.07.25h2.642c.221 0 .433.088.589.245l1.432 1.43a4.14 4.14 0 0 0 4.271 1.002 4.11 4.11 0 0 0 2.788-3.322L20.43 3.59a2.46 2.46 0 0 0-.18-1.658M17.434.565 4.1 3.374a4.164 4.164 0 0 0-2.379 7.069l1.431 1.43a.83.83 0 0 1 .244.59v2.642c.002.37.087.737.25 1.07L19.068.75a2.44 2.44 0 0 0-1.634-.185"
}))));
export { SvgPaperPlaneIcon as ReactComponent };
export default __webpack_public_path__ + "aee9946b4fb528251e106fc98a0265ea.svg";